export const SEARCH_TYPES = {
  EMAIL: "EMAIL",
  PHONE: "PHONE",
}
